import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import useAbsoluteFilter from '@/creditflowresearch/application/BondScreener/useAbsoluteFilter';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';
import { HIDDEN_RATING_AGENCY_IDS } from '@/creditflowresearch/domain/vo/RatingAgency/constants';

const useRatingAgenciesSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getRatingAgencies());
    };
    loadDictionary();
  }, []);

  /*
  * Since July 2019, DBRS and Morningstar have merged,
  * so now we only display DBRS and hide Morningstar from filters.
  * */
  const items = useMemo(
    () => mapToCheckboxOptions(filters?.ratingAgencyIds, dictionary, (item) => `${ item.displayName } (${ item.abbreviation })`)
      .filter((item) => !HIDDEN_RATING_AGENCY_IDS.includes(item.value)),
  [dictionary, filters?.ratingAgencyIds]);

  const checkboxFilter = useCheckboxFilter({ filterKey: 'includedRatingAgencyIds', items });
  const allValues = useMemo(() => items.map((item) => item.value), [items]);

  const { isAbsolute, onToggleAbsolute, toggle, toggleAll } = useAbsoluteFilter({
    includedKey: 'includedRatingAgencyIds',
    excludedKey: 'excludedRatingAgencyIds',
    allValues,
    toggle: checkboxFilter.toggle,
    toggleAll: checkboxFilter.toggleAll,
    useFilterContext: useCorporateBondScreenerSidebarFilterContext,
  });

  return { ...checkboxFilter, toggle, toggleAll, isAbsolute, onToggleAbsolute };
};

export default useRatingAgenciesSection;
